import fetchApi from 'services/api/connector';

// eslint-disable-next-line import/prefer-default-export
export const getTags = (ws) => fetchApi(`ws/${ws}/tags`);
